/*
 * � 2020 Microsoft. All rights reserved.
 */

define('MenuUI/StatsDetailMenu',['pixi', 'absolute', 'lodash', 'MenuUI/MenuTab', 'gameconfig', 'MenuUI/Menu',
	'absolute/screenmetrics',
	'MenuUI/ChallengeTile',
	'Solitaire/SolitaireGameMode',
	'Solitaire/SolitaireStatistics',
	'MenuUI/StatsItemModel',
	'MenuUI/StatsOverviewTile',
	'MenuUI/ControlFocusManager',
	'MenuUI/SideBar',
	'Managers/ScaleManager',
	'Managers/ScrollManager'
],
	function (
		PIXI, Absolute, _, MenuTab, GameConfig, Menu, ScreenMetrics, ChallengeTile, SolitaireGameMode,
		SolitaireStatistics, StatsItemModel, StatsOverviewTile, ControlFocusManager,
		SideBar, ScaleManager, ScrollManager
	) {

		var StatsDetailMenu = function (ui, game) {

			this.initStatsDetailMenu(ui, game);
		};

		StatsDetailMenu.prototype = Object.create(Absolute.Screen.prototype);

		StatsDetailMenu.prototype.initStatsDetailMenu = function (ui, game) {

			Absolute.Screen.call(this);

			this.ui = ui;
			this.game = game;

			this.controlFocusManager = new ControlFocusManager();

			var background = PIXI.Sprite.fromFrame('win10_MS_bg.png');
			this.background.addChild(background);

			this.clickHandler = this.handleGameInput.bind(this);

			window.addEventListener('click', this.clickHandler);


			ScaleManager.addElement(this, { scaleChangeSource: 'Full' });
		};


		StatsDetailMenu.prototype.onShow = function () {
			if (this.menu) {
				this.menu.onShow();
			}
			this.game.menuBar.onShow(true, true, false, SolitaireGameMode.getModeById(this.statsDetailModel._gameMode));
			this.initControls();
			if (!this.touchContainer) this.initTouchInterface();
			if (!this.sidebar) this.initSidebar();
			this.addChild(this.sidebar);
			this.scrollTo(0);
			this.addChild(this.game.menuBar);
			this.handleResize();
			ScrollManager.add(this, this.doScroll, this);
		};

		StatsDetailMenu.prototype.onHide = function () {
			this.container.children = [];
			this.resetControlManager();
			this.controlFocusManager.removeAllControls();
			ScrollManager.remove(this);
		};

		StatsDetailMenu.prototype.initControls = function () {
			this.controlFocusManager.addControl(this.game.menuBar.controlGroup[0], false, 'LeftButtons');
			this.controlFocusManager.addControl(this.game.menuBar.controlGroup[1], false, 'LeftButtons');
			if (this.game.menuBar.fullScreenEnabled) {
				this.controlFocusManager.addControl(this.game.menuBar.controlGroup[3], false, 'RightButtons');
			}
			for (var i = 0; i < this.controlFocusItems.length; i++) {
				this.controlFocusManager.addControl(this.controlFocusItems[i], false, 'StatsTiles');
			}
		};

		StatsDetailMenu.prototype.loadStats = function (statsDetailModel) {
			this.controlFocusItems = [];

			if (this.menu) {
				this.removeChild(this.menu);
			}

			var statsTiles = [];

			var tileConfig = {
				width: 565,
				height: 512,
				
                titleFontSize: 22
			};


			// Challenges
			this.statsDetailModel = statsDetailModel;
			_.each(statsDetailModel.StatsItemModels, function (statsModel) {
				statsModel.isDetailedStats = true;
				var statsOverviewTile = new StatsOverviewTile(tileConfig, statsModel, this);
				statsTiles.push(statsOverviewTile);
				this.controlFocusItems.push(statsOverviewTile);
			}, this);

			this.menu = new Menu(_.extend({
				'tiles': statsTiles,
				'tilePaddingX': Absolute.Coords.x(25),
				'tilePaddingY': Absolute.Coords.y(25),
				'keepOneLine': true,
				'tilesInOneLine': 3
			}, ScaleManager.scaleParams['MenuConfigs']['MainMenuConfigs']));

			this.menu.x = Absolute.Coords.x(90);

			this.currentWidth = Absolute.Coords.x(1840);
			this.scrollable = new PIXI.DisplayObjectContainer();
			this.container = new PIXI.DisplayObjectContainer();

			this.container.addChild(this.menu);

			this.scrollable.addChild(this.container);
			this.addChild(this.scrollable);
			this.scrollable.width = this.currentWidth;

		};

		StatsDetailMenu.prototype.handleResize = function () {
			if (!this.scrollable) return;
			this.container.y = (this.game.menuBar.menuButton.y + this.game.menuBar.menuButton.height)
				* (this.container.width / ScaleManager.width)
				* (ScaleManager.height / Absolute.Coords.y(800));
			this.updatePagesPositions();
			this.scrollable.height = (this.currentWidth / this.container.width)
				* (Absolute.Coords.y(985) / ScaleManager.height)
				* (ScaleManager.width / Absolute.Coords.x(1840)) * this.currentHeight;
			this.scrollable.width = this.currentWidth;
			this.scrollableFakeHeight = this.scrollable.height + Absolute.Coords.x(210);
			if ((this.scrollable.y < 0) && ((this.scrollableFakeHeight + this.scrollable.y) < Absolute.Coords.y(1080))) {
				this.scrollable.y = Absolute.Coords.y(1080) - this.scrollableFakeHeight;
			}
			this.updateSidebar();
			this.container.x = Absolute.Coords.x(this.sidebar.visible ? -30 : 0);
		};

		StatsDetailMenu.prototype.updatePagesPositions = function () {
			var prevChild, scale = Math.max(this.container.width / this.currentWidth, 0.7),
				xPos = Absolute.Coords.x(50), yGap = Absolute.Coords.y(70) * scale;
			this.currentHeight = Absolute.Coords.y(50);
			this.container.children.forEach(function (c) {
				c.x = xPos;
				c.y = 0;
				this.currentHeight += c.height + (prevChild ? yGap : 0);
				prevChild = c;
			}.bind(this));
		};

		StatsDetailMenu.prototype.handleStatsTileClick = function (gameMode) {

		};

		StatsDetailMenu.prototype.handleCommand = function (command) {
			this.selectSection(command);
			switch (command) {
				case 'Right': {
					this.controlFocusManager.focusNextControl(1);
					break;
				}
				case 'Left': {
					this.controlFocusManager.focusNextControl(-1);
					break;
				}
				case 'Up': {
					this.controlFocusManager.focusNextControl(-1);
					break;
				}
				case 'Down': {
					this.controlFocusManager.focusNextControl(1);
					break;
				}
				case 'Activate':
					this.controlFocusManager.activateCurrentControl();
					break;
				case 'Unfocus':
					this.controlFocusManager.unfocusCurrentControl();
					break;
			}

		};

		StatsDetailMenu.prototype.selectSection = function (command) {
			if (command === 'Tab' || command === 'ShiftTab') {
				this.controlFocusManager.focusCurrentControl();
				if (command === 'Tab') {
					if (
						this.controlFocusManager.currentFocusGroup ===
						this.controlFocusManager.getLastControl().focusGroup
					) {
						this.controlFocusManager.setFocusGroup('LeftButtons');
					} else {
						this.controlFocusManager.nextFocusGroup();
					}
				} else if (command === 'ShiftTab') {
					if (
						this.controlFocusManager.currentFocusGroup ===
						this.controlFocusManager.getFirstControl().focusGroup
					) {
						this.controlFocusManager.setFocusGroup(this.controlFocusManager.getLastControl().focusGroup);
					} else {
						this.controlFocusManager.prevFocusGroup();
					}
				}
			}
		};

		StatsDetailMenu.prototype.handleGameInput = function () {
			this.resetControlManager();
		};

		StatsDetailMenu.prototype.resetControlManager = function () {
			this.controlFocusManager.unfocusCurrentControl();
		};

		StatsDetailMenu.prototype.initSidebar = function () {
			this.sidebar = new SideBar({
				availableHeight: 200, partialHeight: 100,
				onScrollUpdate: function (p) { }.bind(this)
			});
			this.addChild(this.sidebar);
			this.sidebar.position.set(Absolute.Coords.x(1900), Absolute.Coords.y(67));
		};

		StatsDetailMenu.prototype.updateSidebar = function () {
			if (!this.sidebar || !this.scrollable) return;
			var height = this.game.menuBar.menuBarHeight;
			var screenScaleX = ScaleManager.width / Absolute.Coords.x(1920),
				screenScaleY = ScaleManager.height / Absolute.Coords.y(1080);
			this.sidebar.scale.set(1, 1);
			this.sidebar.width = this.sidebar.width / screenScaleX;
			this.sidebar.height = this.sidebar.height / screenScaleY;
			this.sidebar.y = height / screenScaleY;
			this.sidebar.x = Absolute.Coords.x(1900) - (this.sidebar.width - (this.sidebar.width * screenScaleX));
			var availableHeight, partialHeight, posY;
			availableHeight = this.scrollableFakeHeight;
			partialHeight = Absolute.Coords.x(1080);
			posY = availableHeight - Absolute.Coords.y(1080);
			this.sidebar.resetDimensions(availableHeight, partialHeight, function (p) {
				var y = -Math.abs(posY) * p / 100;
				this.scrollable.y = y;
				if (this.scrollable.y > 0) this.scrollable.y = 0;
				if (Math.abs(this.scrollable.y) > posY) {
					this.scrollable.y = -posY;
				}
			}.bind(this), (ScaleManager.height - height));
			this.sidebar.visible = false;
			this.sidebar.visible = (partialHeight < availableHeight);
			if (this.sidebar.visible) {
				this.sidebar.updateHandleByPercent(100 * Math.abs(this.scrollable.y) / Math.abs(posY));
			} else {
				this.scrollable.y = 0;
			}
		};

		StatsDetailMenu.prototype.initTouchInterface = function () {
			// Dragging and panning
			this.lastDeltaY = 0;
			this.startY = 0;
			var hitArea = new PIXI.Rectangle(0, 0, Absolute.Coords.x(1920), Absolute.Coords.y(1080));
			this.touchContainer = new PIXI.DisplayObjectContainer();
			this.touchContainer.interactive = true;
			this.touchContainer.hitArea = hitArea;
			this.touchContainer.addChild(this.scrollable);
			this.touchContainer.mousedown = this.touchContainer.touchstart = this.handleDragStart.bind(this);
			this.touchContainer.mousemove = this.touchContainer.touchmove = this.handleDrag.bind(this);
			this.touchContainer.mouseupoutside = this.touchContainer.mouseup = this.touchContainer.touchend = this.touchContainer.touchendoutside = this.handleDragEnd.bind(this);
			this.addChild(this.touchContainer);

		};

		StatsDetailMenu.prototype.handleDragStart = function (data) {
			this.dragging = true;
			this.lastDeltaY = 0;
			this.startY = data.getLocalPosition(this.parent).y;
			this.enableButtons(false);
		};

		StatsDetailMenu.prototype.handleDrag = function (data) {

			if (!this.dragging) {
				return;
			}

			var pos = data.getLocalPosition(this.parent),
				delta = pos.y - this.startY;

			this.scrollTo(this.scrollable.y + ((delta - this.lastDeltaY) * ScreenMetrics.devicePixelRatio));

			this.lastDeltaY = delta;
		};

		StatsDetailMenu.prototype.handleDragEnd = function (data) {

			if (!this.dragging) {
				return;
			}
			this.dragging = false;
		};

		StatsDetailMenu.prototype.enableButtons = function (enable) {

			var i, l;

			for (i = 0, l = this.scrollable.children.length; i < l; i++) {
				this.scrollable.children[i].interactive = enable;
			}

		};

		StatsDetailMenu.prototype.scrollTo = function (y) {
			if (!this.scrollable) return;
			if (this.scrollableFakeHeight <= Absolute.Coords.y(1080)) {
				this.scrollable.y = 0;
				return;
			}
			this.scrollable.y = y;
			if (this.scrollable.y > 0) this.scrollable.y = 0;
			var posY = this.scrollableFakeHeight - Absolute.Coords.y(1080);
			if (Math.abs(this.scrollable.y) > posY) {
				this.scrollable.y = -posY;
			}
			if (this.sidebar) this.sidebar.updateHandleByPercent(100 * Math.abs(this.scrollable.y) / Math.abs(posY));
		};


		StatsDetailMenu.prototype.doScroll = function (e) {
			if (this.scrollableFakeHeight < Absolute.Coords.y(1080)) return;
			var deltaY = 0;
			if (!e) e = window.event;
			if (e.wheelDelta) {
				deltaY = e.wheelDelta / 15;
			} else if (e.detail) {
				deltaY = -e.detail / 3;
			}
			this.scrollTo(this.scrollable.y + (deltaY * 100));
		};

		return StatsDetailMenu;

	});



